import { AlertTriangle, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export const ErrorState = ({ message, onRetry, testId = "error-state" }) => (
  <Alert variant="destructive" data-testid={testId} className="bg-card">
    <AlertTriangle className="h-4 w-4" />
    <AlertTitle>Kunne ikkje hente data</AlertTitle>
    <AlertDescription className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <span>{message}</span>
      {onRetry ? (
        <Button size="sm" variant="outline" onClick={onRetry} data-testid={`${testId}-retry-button`} className="bg-card">
          <RefreshCw className="mr-2 h-4 w-4" /> Prøv igjen
        </Button>
      ) : null}
    </AlertDescription>
  </Alert>
);
